<nav [class.extended]="isExtended()">
  <button class="reset extend-toggle-button" (click)="toggleExtended()">
    <span class="material-symbols-rounded-l">
      {{ isExtended() ? 'arrow_menu_close' : 'arrow_menu_open' }}
    </span>
  </button>

  <menu>
    @for (item of menu; track $index) {
      <li [class.active]="moduleLink.isActive">
        <div class="menu-item">
          <a
            class="module-link"
            #moduleLink="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }"
            [routerLink]="item.path"
            routerLinkActive="active"
            [matTooltip]="isExtended() ? '' : (item.label | translate)"
            matTooltipPosition="after"
          >
            <span class="material-symbols-rounded-l">
              {{ item.icon }}
            </span>

            @if (isExtended()) {
              <span>{{ item.label | translate }}</span>
            }
          </a>

          @if (item.submodules.length > 0) {
            <button class="reset caret-btn" (click)="toggleIsOpen(item.path)">
              <span class="material-symbols-rounded-s">
                {{ openedItems().has(item.path) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </span>
            </button>
          }
        </div>

        @if (isExtended()) {
          @for (submodule of item.submodules; track submodule.label) {
            <a
              class="submodule-link"
              [class.opened]="openedItems().has(item.path)"
              #submoduleLink="routerLinkActive"
              routerLinkActive="active"
              [routerLink]="item.path + '/' + submodule.path"
              [routerLinkActiveOptions]="{ exact: false }"
            >
              {{ submodule.label | translate }}
            </a>
          }
        }
      </li>
    }

    <li>
      <div class="menu-item">
        <a
          target="_blank"
          [href]="dataLakeUrl"
          class="module-link"
          [matTooltip]="isExtended() ? '' : ('DATA_LAKE' | translate)"
          matTooltipPosition="after"
        >
          <span class="material-symbols-rounded-l"> speed </span>

          <span>{{ isExtended() ? ('DATA_LAKE' | translate) : '' }}</span>
        </a>
      </div>
    </li>
  </menu>
</nav>
